var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{staticClass:"img",attrs:{"width":_vm.size,"height":_vm.size,"src":_vm.src,"alt":_vm.alt,"title":_vm.title}}):_c('Icon',{attrs:{"name":"accountCircle","size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }